export enum ProcessType {
  MOVE_IN = 'MOVE_IN',

  MOVE_OUT = 'MOVE_OUT',

  SWITCH = 'SWITCH',
}
